export const getters = {
  isAppLoading: (state) => {
    return state.isLoading;
  },

  isNotificated: (state) => {
    return state.notification.showed;
  },
};
